export const IN_DEVELOPMENT = process.env.NODE_ENV === "development";
export const publicPath = IN_DEVELOPMENT ? "" : "/vue/dist";
